export const environment = {
  production: false,
  staging: false,
  development: true,
  type: 'DEV',
  translationFilePath: '../common/translation/',
  frameworkURL: 'https://my.win-dev.easy-cert.cloud/',
  apiBaseURL: 'https://inputs.win-dev.easy-cert.cloud/backend/api/v1'
};
